import LocaleService from '@/services/LocaleService'

export const parseNodeName = (nodeValues: any): string => {
  if (!nodeValues) return ''
  const localeService = new LocaleService()
  if (nodeValues[localeService.locale]) {
    const node: string = nodeValues[localeService.locale]
    const splitCat: Array<string> = node.split('_')
    if (splitCat.length > 1) {
      return splitCat.slice(1).join('_')
    }
    return node
  }
  return '-'
}
